import debounce from 'lodash.debounce';
import { useRef } from 'react';

export function useDebounce(func: any, wait: number | undefined, options: any | undefined) {
  return useRef(debounce(func, wait, options)).current;
}
